import { InjectionToken } from '@angular/core';
import { environment } from '@env/environment';

/**
 * Fixed UTC offset (e.g. `'+0300'`) that every service-slot date/time
 * (pickup/delivery windows) must render in, regardless of the device timezone.
 *
 * Set per brand through `environment.serviceTimeZoneOffset` (Artaah = KSA, UTC+3).
 * When undefined, service times keep using the backend-provided offset strings.
 */
export const SERVICE_TIME_ZONE_OFFSET = new InjectionToken<string | undefined>(
  'SERVICE_TIME_ZONE_OFFSET',
  {
    providedIn: 'root',
    factory: () => environment.serviceTimeZoneOffset,
  },
);
